import { useEffect } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import styled from 'styled-components';
import ScrollToTop from '@/components/common/ScrollToTop';
import LoginAuto from '@/components/common/LoginAuto';
import CustomModal from '@/components/common/CustomModal';
import { useAppDispatch, useAppSelector } from '@/hooks/useReduxHooks';
import CustomerRefund from '@/pages/CustomerRefund';
import NotFound from '@/pages/NotFound';
import VerifiactionRedirect from '@/pages/VerificationRedirect';
import PassportValidate from '@/pages/PassportValidate';
import RefundResult from '@/pages/RefundResult';
import RefundInfo from '@/pages/RefundInfo';
import { IGlobalState } from '@/store';
import { isNationIncluded, Iso639_1Code } from '@repo/utils';
import RefundInfoLeaflet from '@/pages/RefundInfoLeaflet';
import PassportRedirect from '@/pages/PassportRedirect';
import Redirect from '@/pages/Redirect/Redirect';
import Home from './pages/Home';
import Receipt from './pages/Receipt';
import ReceiptPreviewModal from './components/Receipt/ReceiptPreviewModal';
import { routes } from './constant/routes.const';
import DepartureDate from './pages/DepartureDate';
import { BANK_CALL_GUIDE_MODAL, CASH_PICKUP_NATIONS } from '@repo/constants';
import PassportPage from './pages/Inquiry/Passport.page';
import EmailPage from './pages/Inquiry/Email.page';
import QnaPage from './pages/Inquiry/Qna.page';
import Layout from './components/common/Layout';
import FaqPage from './pages/Inquiry/Faq.page';
import {
  AnswerdModal,
  BankCallGuideModal,
  CashPickupGuideModal,
} from '@repo/components';
import { updateNewAnswer } from './api';
import { useMutation } from 'react-query';

function RouterContainer() {
  const dispatch = useAppDispatch();
  const { nationality, globalModalInfo, hasNewAnswer, passportNumber } =
    useAppSelector((state) => state) as IGlobalState;
  const LANG = nationality === 'KOR' ? 'KOR' : 'ENG';
  const selectElement = document.querySelector('.goog-te-combo');

  function changeGoogleTranslateLanguage(nationality: string | null) {
    const nation = Iso639_1Code(nationality);
    if (!nation) return;
    //@ts-ignore
    selectElement.value = nation;
    //@ts-ignore
    selectElement.dispatchEvent(new Event('change'));
  }

  const onCloseModal = () => {
    dispatch({
      type: 'UPDATE_HOME_MODAL_STATE',
      payload: { isActive: false, data: null, type: null },
    });
  };
  console.log('KIOSK TEST1');
  useEffect(() => {
    selectElement && changeGoogleTranslateLanguage(nationality);
  }, [selectElement, nationality]);

  const { mutate: readAnswer } = useMutation(
    () => updateNewAnswer(passportNumber || ''),
    {
      onSuccess: () => {
        sessionStorage.setItem('inquiry-endpoint', routes.home);
        window.location.href = routes.inquiryQna;
      },
      onError: (error: any) => {
        alert(error.message);
      },
    },
  );

  return (
    <Container>
      <Translation id='google_translate_element'></Translation>
      <Router>
        <Redirect />
        <LoginAuto />
        <ScrollToTop />
        <Switch>
          <Layout>
            <Route path={routes.passport} component={PassportValidate} exact />
            <Route path={routes.departureDate} component={DepartureDate} />
            <Route
              path='/redirect/:passportNumber'
              component={PassportRedirect}
            />
            <Route
              path='/email-verification/:id/:verifiedEmail'
              component={VerifiactionRedirect}
            />
            <Route path={routes.home} component={Home} />
            <Route path={routes.refundResult} component={RefundResult} />
            <Route path={routes.customerRefund} component={CustomerRefund} />
            <Route
              path={routes.refundInfoLeaflet}
              component={RefundInfoLeaflet}
            />
            <Route path={routes.refundInfo} component={RefundInfo} />
            <Route path={routes.receipt} component={Receipt} />
            <Route path={routes.inquiryFaq} component={FaqPage} />
            <Route path={routes.inquiryPassport} component={PassportPage} />
            <Route path={routes.inquiryEmail} component={EmailPage} />
            <Route path={routes.inquiryQna} component={QnaPage} />
          </Layout>
          <Route>
            <NotFound />
          </Route>
        </Switch>
        <AnswerdModal isOpen={hasNewAnswer} onClick={readAnswer} lang={LANG} />
      </Router>
      {/* 커스텀 모달 */}
      {globalModalInfo?.type === 'CUSTOM' && globalModalInfo?.isActive && (
        <CustomModal onClose={onCloseModal} {...globalModalInfo?.data} />
      )}
      {globalModalInfo?.type === 'PREVIEW_RECEIPT' &&
        globalModalInfo?.isActive && (
          <ReceiptPreviewModal
            onClose={onCloseModal}
            {...globalModalInfo?.data}
          />
        )}
      {isNationIncluded(CASH_PICKUP_NATIONS, nationality) &&
        globalModalInfo?.type === 'CASH_PICKUP_GUIDE' && (
          <CashPickupGuideModal
            isOpen={globalModalInfo?.type === 'CASH_PICKUP_GUIDE'}
            onClose={onCloseModal}
          />
        )}
      {(nationality === 'CHN' || nationality === 'JPN') && (
        <BankCallGuideModal
          isOpen={globalModalInfo?.type === 'BANK_INQUIRY_GUIDE'}
          title={BANK_CALL_GUIDE_MODAL[nationality].title}
          questionTitle={BANK_CALL_GUIDE_MODAL[nationality].questionTitle}
          questionText={BANK_CALL_GUIDE_MODAL[nationality].questionText}
          answerTitle={BANK_CALL_GUIDE_MODAL[nationality].answerTitle}
          answerText={BANK_CALL_GUIDE_MODAL[nationality].answerText}
          btnTitle={BANK_CALL_GUIDE_MODAL[nationality].btnTitle}
          onClick={onCloseModal}
        />
      )}
    </Container>
  );
}

export default RouterContainer;

const Container = styled.div`
  position: static;
`;

const Translation = styled.div`
  position: fixed;
  z-index: 200;
  @media ${(props) => props.theme.desktop} {
    right: 42%;
    top: 2px;
  }
  @media ${(props) => props.theme.mobile} {
    top: 0px;
    right: 20px;
  }
`;

const InfoTitle = styled.span`
  display: block;
  font-weight: 600;
  line-height: 150%;
`;
